// extracted by mini-css-extract-plugin
export default {"smallMarginY":"TZE4_bIAB7pbWW8CpsIw","mediumMarginY":"C1p5aES0aTv06kcvr_KU","largeMarginY":"jex1tEwDmsOSsL8rpdwp"};